var angular = require('angular');
var _module = require('../components/module');

/*
toNumber
Converts a string to a number using a regular expression
*/

_module.filter('toNumber', [
    function toNumber() {
        return function(str, maxDecimalPlaces) {
            str = '' + (str || 0);
            var num = parseFloat(str.replace(/([^0-9\.])/gi, '')) || '';

            if(angular.isDefined(maxDecimalPlaces)) {
                maxDecimalPlaces = parseInt(maxDecimalPlaces);
                var splitNum = String(num).split('.');
                num = splitNum.shift();
                num += '.' + splitNum.join('').substr(0, maxDecimalPlaces);
                num = parseFloat(num);
            }

            return num;
        };
    }
]);


